export default __webpack_public_path__ + "static/smile_final-490efcff8c72f647cc9807db38bd442d.png";